var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAfternoon = function SvgAfternoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.209 1.417H7.792V4.25h1.417zM5.996 4.994 3.992 2.99 2.991 3.992l2.003 2.004zM4.25 7.792H1.417v1.416H4.25zm-1.26 5.216 1.002 1.002 2.004-2.004-1.002-1.002zm4.802 2.575h1.417V12.75H7.792zm3.213-3.577 2.003 2.004 1.002-1.002-2.003-2.004zm1.745-4.214v1.416h2.834V7.792zm1.26-3.8L13.008 2.99l-2.003 2.004 1.002 1.002zM8.5 5.667a2.833 2.833 0 1 0 0 5.666 2.833 2.833 0 0 0 0-5.666"
  })));
};
export default SvgAfternoon;